import { Clinic } from './clinic';
import { ClinicianView } from './clinician';

export enum RISK_LEVEL {
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
}

export const RiskLevelMap = {
  LOW: 'LOW',
  MODERATE: 'MODERATE',
  HIGH: 'HIGH',
};

export enum PATIENT_PROGRESS {
  UNKNOWN = 'UNKNOWN',
  REFERRAL = 'REFERRAL',
  ASSESSMENT_WAITING = 'ASSESSMENT_WAITING',
  ASSESSMENT_COMPLETE = 'ASSESSMENT_COMPLETE',
  ON_WAITLIST = 'ON_WAITLIST',
  ASSIGNED_AWAITING_THERAPY = 'ASSIGNED_AWAITING_THERAPY',
  IN_THERAPY = 'IN_THERAPY',
  DISCHARGED = 'DISCHARGED',
  SELF_CARE = 'SELF_CARE',
  PREVENTATIVE_CARE = 'PREVENTATIVE_CARE',
  STEPPED_UP = 'STEPPED_UP',
  COURSE_ENROLLED = 'COURSE_ENROLLED',
}

export const PatientProgressMap = {
  UNKNOWN: 'Unknown',
  REFERRAL: 'Referred',
  ASSESSMENT_WAITING: 'Awaiting Assessment',
  ASSESSMENT_COMPLETE: 'Assessment Completed',
  ON_WAITLIST: 'On Waitlist',
  ASSIGNED_AWAITING_THERAPY: 'Awaiting Therapy',
  IN_THERAPY: 'In Therapy',
  DISCHARGED: 'Discharged',
  SELF_CARE: 'Limbic Self Care',
  PREVENTATIVE_CARE: 'Limbic Prevent',
  STEPPED_UP: 'Stepped up',
  COURSE_ENROLLED: 'Enrolled in Course',
};

export type CourseEnrollment = {
  course: {
    name: string;
  };
  startDate: string;
};

export interface IPatient {
  id: string;
  signupCode: string;
  dob?: string;
  phoneMobile?: string;
  analyticsData: unknown;
  progress: PATIENT_PROGRESS;
  status: 'active' | 'inactive' | 'pending';
  /** @deprecated Legacy fallback until LCX-965 backfill. Use nameFirst/nameLast on writes. */
  name?: string;
  nameFirst?: string;
  nameLast?: string;
  email?: string;
  clinicId: string;
  clinic: Clinic;
  clinician?: ClinicianView;
  clinicianId?: string;
  createdAt: string;
  updatedAt: string;
  weeklyQuestionnaires: string[];
  sessionDate: string;
  firstLogin: string;
  externalId: string;
  utcOffset: number;
  isEmailVerified: boolean;
  previousSessionDate: string;
  demoUser: boolean;
  isSubscribed: boolean;
  password: string;
  locked: boolean;
  lockedUntil: string;
  weekliesTriggeredEvery: any;
  riskLevel: RISK_LEVEL;
  courseEnrollments: CourseEnrollment[];
}

export type PatientView = Pick<
  IPatient,
  | 'id'
  | 'signupCode'
  | 'dob'
  | 'phoneMobile'
  | 'analyticsData'
  | 'progress'
  | 'clinic'
  | 'clinician'
  | 'name'
  | 'nameFirst'
  | 'nameLast'
  | 'email'
  | 'sessionDate'
  | 'createdAt'
  | 'updatedAt'
  | 'courseEnrollments'
>;

export type SearchPatientsFuzzy = {
  data: PatientView[];
  cursor: string;
};

export type PatientInput = Pick<
  IPatient,
  'nameFirst' | 'nameLast' | 'email' | 'analyticsData' | 'clinicianId' | 'riskLevel' | 'progress'
> & {
  clinicName: string;
  sessionDate: string | null;
};
